var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_232_3459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 8H3.75C1.66667 8 0 6.33333 0 4.25C0 2.16667 1.66667 0.5 3.75 0.5H12.9167C15 0.5 16.6667 2.16667 16.6667 4.25C16.6667 6.33333 15 8 12.9167 8ZM10.8333 4.25C10.8333 5.41667 11.75 6.33333 12.9167 6.33333C14.0833 6.33333 15 5.41667 15 4.25C15 3.08333 14.0833 2.16667 12.9167 2.16667C11.75 2.16667 10.8333 3.08333 10.8333 4.25Z",
    fill: "#D4D4DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.9167 17.5H3.75C1.66667 17.5 0 15.8333 0 13.75C0 11.6667 1.66667 10 3.75 10H12.9167C15 10 16.6667 11.6667 16.6667 13.75C16.6667 15.8333 15 17.5 12.9167 17.5ZM1.66667 13.75C1.66667 14.9167 2.58333 15.8333 3.75 15.8333C4.91667 15.8333 5.83333 14.9167 5.83333 13.75C5.83333 12.5833 4.91667 11.6667 3.75 11.6667C2.58333 11.6667 1.66667 12.5833 1.66667 13.75Z",
    fill: "#D4D4DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_232_3459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.4967,
    height: 17,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.04255dc0fc2b9c66873eeaa622608fae.svg";
export { ForwardRef as ReactComponent };